export const config = {
  /**
   *  The URL for looking up LOINC forms in the Clinical Table Search Service
   */
  searchURL: 'https://lforms-service.nlm.nih.gov/api/loinc_items/v3/search?type=form&available=true',

  /**
   *  The ID of the element on the page where the form is rendered.
   */
  formContainer: 'formContainer'
};
